import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const StaffLoginForm = ({ email, setEmail, password, setPassword, error, submitting, onSubmit }) => (
  <form
    data-testid="staff-login-form"
    onSubmit={onSubmit}
    className="space-y-5 bg-white border border-[#33424f]/20 border-t-0 p-6 shadow-[4px_4px_0_0_rgba(51,66,79,0.08)]"
  >
    <div>
      <Label className="subtitle text-[10px] uppercase tracking-[0.2em] text-[#50493b]">
        Email
      </Label>
      <Input
        data-testid="login-email-input"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="mt-2 border-[#33424f]/30 focus:border-[#39678f] focus:ring-[#39678f] font-body"
        required
      />
    </div>
    <div>
      <Label className="subtitle text-[10px] uppercase tracking-[0.2em] text-[#50493b]">
        Password
      </Label>
      <Input
        data-testid="login-password-input"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="mt-2 border-[#33424f]/30 focus:border-[#39678f] focus:ring-[#39678f] font-body"
        required
      />
    </div>
    {error && (
      <div
        data-testid="login-error"
        className="border border-[#b30035] bg-[#fbe4ea] text-[#7a0024] text-sm p-3 font-body"
      >
        {error}
      </div>
    )}
    <Button
      data-testid="login-submit-btn"
      type="submit"
      disabled={submitting}
      className="w-full bg-[#39678f] hover:bg-[#2c5272] text-white subtitle uppercase tracking-wider h-11"
    >
      {submitting ? "Verifying…" : "Sign in"}
    </Button>
    <div className="font-body text-xs text-[#50493b] border-t border-[#33424f]/15 pt-4">
      <span className="subtitle text-[#33424f]">Demo account:</span>{" "}
      admin@jackstone.io / admin123
    </div>
  </form>
);
